import React from 'react';
import { motion } from 'framer-motion';
import styles from './AboutUs.module.css';
import BoardMember from './BoardMember/BoardMember';
import HappyDonors from './HappyDonors/HappyDonors';

const AboutUs = () => {
  const valuesData = [
    {
      title: 'Compassion',
      icon: "/images/Our Values/compassion img.webp",
      text: 'Our compassionate approach ensures that every individual we serve is treated with dignity and love. Through compassion, we strive to heal, uplift, and build a more humane and inclusive society for all.'
    },
    {
      title: 'Diversity & Inclusion',
      icon: '/images/Our Values/Diversity & Inclusion img.webp',
      text: 'ZFoundation celebrates diversity and ensures inclusion by empowering all—regardless of gender, age, or background—creating equal opportunities and a united, compassionate community.'
    },
    {
      title: 'Collaboration',
      icon: '/images/Our Values/Collaboration img.webp',
      text: 'Z Foundation thrives on collaboration, uniting communities, partners, and volunteers to drive impactful change through shared goals, collective action, and compassionate service for all.'
    },
    {
      title: 'Accountability',
      icon: '/images/Our Values/Accountability img.webp',
      text: 'Z Foundation upholds accountability by staying transparent, responsible, and committed to our mission—ensuring every action, resource, and outcome serves the community with integrity and trust.'
    }
  ];

  return (
    <div className={styles.mainWrapper}>
      {/* 1. Hero Section with Pattern */}
      <div className={styles.heroBanner}>
        <motion.h1
          initial={{ opacity: 0, scale: 0.8, letterSpacing: "15px" }}
          animate={{ opacity: 1, scale: 1, letterSpacing: "4px" }}
          transition={{ duration: 1.8, ease: "easeOut" }}
          className={styles.heroTitle}
        >
          ABOUT US
          {/* <p className={styles.heroSubtitle}>Capturing moments of change and compassion at ZFoundation</p> */}
        </motion.h1>
      </div>

      {/* 2. Welcome Information Section */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className={styles.welcomeContainer}
      >
        <div className={styles.innerContent}>
          <h2 className={styles.redHeading}>Welcome to Z Foundation</h2>
          <p className={styles.infoText}>
            Z Foundation is a non-profit organization established with a heartfelt mission to uplift the underserved and create lasting, meaningful change in society. Rooted in the values of compassion, inclusivity, and service, we work tirelessly to address the pressing social challenges faced by vulnerable communities across India.
          </p>
          <p className={styles.infoText}>
            At Z Foundation, we believe that real change starts at the grassroots. Our initiatives span across multiple impact areas, women empowerment, youth development, environmental responsibility, and social recognition.
          </p>
        </div>
      </motion.div>

      {/* 3. Our Values Section */}
      <section className={styles.valuesSection}>
        <div className={styles.container}>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={styles.valuesMainHeading}
          >
            Our Values
          </motion.h2>
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            variants={{
              hidden: { opacity: 0 },
              show: {
                opacity: 1,
                transition: {
                  staggerChildren: 0.2
                }
              }
            }}
            className={styles.valuesGrid}
          >
            {valuesData.map((item, index) => (
              <motion.div
                key={index}
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
                }}
                className={styles.valueCard}
              >
                <h3 className={styles.valueCardTitle}>{item.title}</h3>
                <div className={styles.whiteCircle}>
                  <img src={item.icon} alt={item.title} className={styles.centerIcon} />
                </div>
                <p className={styles.valueText}>{item.text}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      <div className={styles.visionWorkSection}>
        <div className={styles.container}>
          <div className={styles.topVisionGrid}>
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className={styles.visionItem}
            >
              <h3 className={styles.redSubHeading}>Our Vision</h3>
              <p className={styles.visionPara}>To build a compassionate and inclusive society by empowering women, children, and underprivileged communities through education, health, and sustainable initiatives, inspiring collective responsibility to create lasting impact and a brighter future for generations to come.</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className={styles.visionItem}
            >
              <h3 className={styles.redSubHeading}>What We Do</h3>
              <p className={styles.visionPara}>Z Foundation is involved in a range of activities, including Women Empowerment, Child Education, Home for Senior citizens, Child Nurture, Humanitarian Relief etc. We believe in taking a holistic approach to address complex issues.</p>
            </motion.div>
          </div>
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className={styles.helpFullWidth}
          >
            <h3 className={styles.redSubHeading}>How You Can Help</h3>
            <p className={styles.visionPara}>As a volunteer, there are several ways in which you can actively contribute to Z Foundation. By offering your time, skills, and resources, you can make a positive impact for those in need. Whether it's assisting an event, participating in fundraising events, or simply lending a helping hand to those less fortunate, your involvement can truly make a difference. Remember, every small act of kindness can go a long way in building a stronger and more supportive community.</p>
          </motion.div>
        </div>
      </div>

      <BoardMember />
      <HappyDonors />
    </div>
  );
};

export default AboutUs;